import { useListContext, useTranslate } from "ra-core";
import { Link } from "react-router";
import { Badge } from "@/components/ui/badge";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";

import { MobileListPage } from "../layout/MobileListPage";
import { TICKET_PRIORITIES, TICKET_STATUSES, nameOf } from "./ticketConstants";

type Ticket = {
  id: number;
  subject: string;
  status: string;
  priority: string;
  created_at: string;
};

/** Tickets on a phone as cards; same reasoning as the project list. */
const TicketCards = () => {
  const { data, isPending } = useListContext<Ticket>();
  if (isPending) return null;
  const tickets = data ?? [];

  if (tickets.length === 0) {
    return (
      <p className="text-sm text-muted-foreground py-8 text-center">
        Nothing here. Tickets you raise, or that are assigned to you, appear
        here.
      </p>
    );
  }

  return (
    <div className="space-y-2">
      {tickets.map((ticket) => (
        <Link
          key={ticket.id}
          to={`/tickets/${ticket.id}/show`}
          className="block rounded-lg border p-3 active:bg-accent/50"
        >
          <div className="font-medium text-sm">{ticket.subject}</div>
          <div className="flex flex-wrap items-center gap-1.5 pt-1.5">
            <Badge variant="outline">
              {nameOf(TICKET_STATUSES, ticket.status)}
            </Badge>
            {ticket.priority !== "normal" ? (
              <Badge variant="secondary">
                {nameOf(TICKET_PRIORITIES, ticket.priority)}
              </Badge>
            ) : null}
            <span className="text-xs text-muted-foreground">
              {new Date(ticket.created_at).toLocaleDateString()}
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
};

export const MobileTicketList = () => {
  const translate = useTranslate();
  return (
    <List
      actions={false}
      title={false}
      sort={{ field: "created_at", order: "DESC" }}
      pagination={<ListPagination rowsPerPageOptions={[25, 50]} />}
    >
      <MobileListPage
        searchPlaceholder={translate("resources.tickets.name", {
          smart_count: 2,
          _: "Tickets",
        })}
      >
        <TicketCards />
      </MobileListPage>
    </List>
  );
};

export default MobileTicketList;
